import React from 'react'
import TopSection from '../components/TopSection'
import { useState } from 'react';
import axios from 'axios'
import ToastNotification from '../components/ToastNotification';

const Contact = () => {

    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [description, setDescription] = useState("");

       const [toast, setToast] = useState({ show: false, message: '', bg: 'success' });
        const showToast = (msg, bg = 'success') => {
            setToast({ show: true, message: msg, bg });
        };




const handleSubmit = async (e) => {
  e.preventDefault();

  const userData = {
    name,
    email,
    description
  };

  try {
    const result = await axios.post(
      "https://api.skyguard.group/api/add-contact",
      userData  
    );

   showToast("Your enquiry has been sent successfully!", "success");   
  
    setName("");
    setEmail("");
    setDescription("");

  } catch (error) {
    console.error("Error submitting form:", error);
    showToast("Fail to send enquiry!", "danger"); 
  }
};

    return (
        <>
            <TopSection title='Contact Us' breadcrumb='Contact Us' />
            <section className='amazing-feature py-5'>
                  <ToastNotification
                    show={toast.show}
                    message={toast.message}
                    bg={toast.bg}
                    onClose={() => setToast({ ...toast, show: false })}
                />
                <div className='container'>

                    <div className='row'>
                        {/* form */}
                        
                        <div className='col-lg-6 col-md-12 '>
                            <div className='text-center mb-5'>
                                <h2 className='main-heading fira-sans-thin text-start fw-bold'>Let's Get in Touch.</h2>
                                <p className='text-start'>We'd love to hear from you! Let us know how we can help.</p>
                                <h6 className='sub-heading text-start'>Or just reach out manually to <span className='text-info'>Skyguardro@gmail.com</span></h6>  
                                <h6 className='sub-heading text-start'>Contact Number <span className='text-info'>+91 9975990399</span></h6>                              
                            </div>
                        </div>

                        <div className='col-lg-6 col-md-12 mb-4 bg-secondary-subtle p-4'>
                            <form onSubmit={handleSubmit}>
                                <div className='mb-3'>
                                    <label htmlFor='name' className='form-label fw-semibold'>Name</label>
                                    <input
                                        type='text'
                                        className='form-control'
                                        id='name'
                                        placeholder='Enter your name'
                                        value={name}
                                        onChange={(e) => setName(e.target.value)}
                                    />
                                </div>
                                <div className='mb-3'>
                                    <label htmlFor='email' className='form-label fw-semibold'>Email</label>
                                    <input
                                        type='email'
                                        className='form-control'
                                        id='email'
                                        placeholder='Enter your email'
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                    />
                                </div>
                                <div className='mb-3'>
                                    <label htmlFor='description' className='form-label fw-semibold'>Description</label>
                                    <textarea
                                        className='form-control'
                                        id='description'
                                        rows='4'
                                        placeholder='Write your message here...'
                                        value={description}
                                        onChange={(e) => setDescription(e.target.value)}
                                    ></textarea>
                                </div>
                                <button type='submit' className='btn btn-custom bg-primary text-white'>Submit</button>
                            </form>
                        </div>

                    </div>
                </div>
            </section>
        </>
    )
}

export default Contact